import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import EmailView from "../views/EmailView.vue";
import StorageView from "@/views/StorageView.vue";
import ProjectView from "@/views/ProjectView.vue";
import OfficeView from "@/views/OfficeView.vue";
import ConferanceView from "@/views/ConferanceView.vue";
import ContactView from "@/views/ContactView.vue";
import NoteView from "@/views/NoteView.vue";
import CalendarView from "@/views/CalendarView.vue";
import SyncroniseView from "@/views/SyncroniseView.vue";

import { show } from "../main";
import TitlesView from "../views/TitlesView.vue";
const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    children: [
      {
        path: "/email",
        name: "email",
        component: EmailView,
      },
      {
        path: "/storage",
        name: "storage",
        component: StorageView,
      },
      {
        path: "/conferance",
        name: "conferance",
        component: ConferanceView,
      },
      {
        path: "/calendar",
        name: "calendar",
        component: CalendarView,
      },
      {
        path: "/project",
        name: "project",
        component: ProjectView,
      },
      {
        path: "/office",
        name: "office",
        component: OfficeView,
      },
      {
        path: "/note",
        name: "note",
        component: NoteView,
      },
      {
        path: "/contact",
        name: "contact",
        component: ContactView,
      },
      {
        path: "/syncronise",
        name: "syncronise",
        component: SyncroniseView,
      },
    ],
  },
  {
    path: "/titles",
    name: "titles",
    component: TitlesView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
